import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Booking System Amadeus Whatahotel**
 *
 * @exports bs_303
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_303
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    // Dates
    const dateBegin = ((document.getElementById('checkIn') || {}).dataset || {}).value || thn.parseUrlParameter('checkIn');
    const dateEnd = ((document.getElementById('checkOut') || {}).dataset || {}).value || thn.parseUrlParameter('checkOut');

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
    }

    // Guests, Adults & Children
    const guestsEl = document.getElementById('RoomAdultChild');
    const guestsElValue = guestsEl && guestsEl.options && guestsEl.options[guestsEl.selectedIndex];
    const guests = parseInt((guestsElValue || '').value || thn.parseUrlParameter('guests'), 10) || 2;

    widgetData.adults = guests;
    widgetData.children = 0;
    widgetData.guests = guests;
    widgetData.rooms = 1;

    // Prices & Currency || No Rooms
    const pricesEl = [...document.querySelectorAll('.bookItemPrice > h3')];
    const prices = pricesEl && pricesEl.map((el) => thn.parseNumber(el.textContent.trim()));
    const currency = pricesEl && pricesEl.length && thn.parseCurrency(pricesEl[0].textContent);

    if (prices.length) {
      widgetData.price = Math.min(...prices);
      widgetData.currency = currency || 'USD';
      widgetData.set = true;
    } else {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_303
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    const tableObj = document.querySelector('.checkoutTable');
    const bookingInfoMap = {};

    const normalizeFieldNames = (text) => text
      .toString()
      .toLowerCase()
      .replace(/[^\w-]+/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/--+/g, '-');

    if (tableObj) {
      Array.from(tableObj.getElementsByTagName('tr')).forEach(function (row) {
        const cells = row.getElementsByTagName('td');
        bookingInfoMap[normalizeFieldNames(cells[0].innerHTML.trim())] = cells[1].innerHTML.trim();
      });
    }

    const bookingNumberEl = document.querySelector('#introSec > div > div > h4 > b');
    const bookingNumber = bookingNumberEl && bookingNumberEl.innerHTML.trim();

    widgetData.dateBegin = bookingInfoMap.checkindate && translateDate(bookingInfoMap.checkindate, thn.data.language);
    widgetData.dateEnd = bookingInfoMap.checkoutdate && translateDate(bookingInfoMap.checkoutdate, thn.data.language);
    widgetData.bookingId = bookingInfoMap.whatahotelreservationcode || bookingNumber || thn.parseUrlParameter('confBooking');
    widgetData.price = bookingInfoMap.dailyrate && thn.parseNumber(bookingInfoMap.dailyrate);
    widgetData.currency = window.currency
            || thn.parseCurrency(bookingInfoMap.dailyrate)
            || 'USD';

    return widgetData;
  };

  return engine;

}

export { factory };
